var render = function render(){var _vm=this,_c=_vm._self._c;return _c('brand-aggregate-page',{attrs:{"storage-key":"foodBrandListData","default-title":"餐饮自提","empty-icon":"🍿"}})
}
var staticRenderFns = []

export { render, staticRenderFns }